import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import {
  getUserSubscriptionLevel,
  LISTING_STATE_DRAFT,
  SUBSCRIPTION_LEVEL_2,
} from '../../util/types';
import { Button, IconReport, ListingLink, NamedLink } from '../../components';
import { EditListingStartupOfferDescriptionForm } from '../../forms';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

import css from './EditListingStartupOfferDescriptionPanel.module.css';

export class EditListingStartupOfferDescriptionPanelComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: [],
      firstImageFromState: null,
    };
  }

  handleSetFirstImage = (file) => {
    if (file) {
      this.setState({ firstImageFromState: [file] })
    } else {
      this.setState({ firstImageFromState: null })
    }
  }

  handleSetInitialValues = (values) => {
    this.setState({ initialValues: values })
  }

  render() {

    const {
      className,
      rootClassName,
      listing,
      disabled,
      ready,
      onSubmit,
      onChange,
      submitButtonText,
      isNewListingFlow,
      panelUpdated,
      updateInProgress,
      errors,
      currentUser,
      hasProviderMarker,
      isDraftListing,
      onHandleValidatonPopup,
      onHandlePreviewPopup,
      onHandleCreateAndBublishListing,
      publishSuccess,
      isProvider,
    } = this.props;

    const isClient =
      currentUser?.attributes?.profile?.publicData?.userType === 'client' && !hasProviderMarker;
    const classes = classNames(rootClassName || css.root, className);
    const currentListing = ensureOwnListing(listing);
    const { description, title, publicData } = currentListing.attributes;

    const startupOfferTitle = publicData?.startupOfferTitle;
    const startupOfferDescription = publicData?.startupOfferDescription;

    const userSubscriptionLevel = getUserSubscriptionLevel(currentUser);
    const subscriptionLevelToLow = userSubscriptionLevel < SUBSCRIPTION_LEVEL_2;

    const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
    const panelTitle = !!startupOfferTitle ? (
      <FormattedMessage
        id="EditListingStartupOfferDescriptionPanel.title"
      />
    ) : <FormattedMessage id="EditListingOfferDescriptionPanel.createTitle" />

    const { initialValues } = this.state;

    return (
      <div className={classes}>
        {subscriptionLevelToLow ? (
          <>
            <h1 className={css.title}>{panelTitle}</h1>
            <FormattedMessage id="EditListingOfferDescriptionPanel.upgradePlan" />
            <NamedLink name="SubscriptionPage" className={css.upgradeLink}>
              <Button className={css.submitButton} type="button">
                Upgrade
              </Button>
            </NamedLink>
          </>
        ) : (
          <>
            <h1 className={css.title}>{panelTitle}</h1>
            <EditListingStartupOfferDescriptionForm
              className={css.form}
              initialValues={{
                startupOfferTitle: initialValues?.startupOfferTitle || publicData?.startupOfferTitle,
                startupReward: initialValues?.startupReward || publicData?.startupReward,
                startupOfferDescription: initialValues?.startupOfferDescription || startupOfferDescription,
              }}
              saveActionMsg={submitButtonText}
              onSubmit={values => {
                const {
                  startupOfferTitle,
                  startupReward,
                  startupOfferDescription,
                } = values;

                const trimmedStartupOfferTitle = startupOfferTitle.trim();

                const updateValues = {
                  title,
                  description,
                  publicData: {
                    startupOfferTitle: trimmedStartupOfferTitle,
                    startupReward,
                    startupOfferDescription,
                  },
                };

                return onSubmit(updateValues);

              }}
              onChange={onChange}
              disabled={disabled}
              ready={ready}
              updated={panelUpdated}
              updateInProgress={updateInProgress}
              fetchErrors={errors}
              isClient={isClient}
              isNewListingFlow={isNewListingFlow}
              isDraftListing={isDraftListing}
              currentUser={currentUser}
              publicData={publicData}
              onHandleValidatonPopup={onHandleValidatonPopup}
              onHandlePreviewPopup={onHandlePreviewPopup}
              onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
              listing={listing}
              publishSuccess={publishSuccess}
              isProvider={isProvider}
              handleSetInitialValues={this.handleSetInitialValues}
              startupOfferDescription={startupOfferDescription}
            />
          </>
        )}
      </div>
    );
  }
}

EditListingStartupOfferDescriptionPanelComponent.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingStartupOfferDescriptionPanelComponent.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const EditListingStartupOfferDescriptionPanel = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EditListingStartupOfferDescriptionPanelComponent);

export default EditListingStartupOfferDescriptionPanel;
